
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.2 8.658l.073.009 2.834.46A.669.669 0 015 10.46h-.107l-1.1-.18a4.78 4.78 0 004.16 2.387 4.72 4.72 0 004.427-2.914.667.667 0 01.873-.373.667.667 0 01.38.853 6.147 6.147 0 01-11.053.554l-.247 1.333a.667.667 0 01-.666.547h-.12a.667.667 0 01-.534-.814l.5-2.666a.293.293 0 01.047-.114.56.56 0 01.047-.126l.06-.067a.667.667 0 01.12-.12A.767.767 0 012 8.667h.053a.607.607 0 01.22 0zm5.504-6.631a6.147 6.147 0 015.703 3.186l.246-1.333a.677.677 0 011.334.24l-.5 2.667a.413.413 0 01-.047.126.387.387 0 01-.033.107.713.713 0 01-.094.107l-.053.066a.52.52 0 01-.133.074.22.22 0 01-.067.04.621.621 0 01-.227.04h-.106l-2.834-.474a.675.675 0 11.214-1.333l1.1.18a4.78 4.78 0 00-4.16-2.387 4.72 4.72 0 00-4.454 2.94.667.667 0 01-.873.367.667.667 0 01-.367-.867 6.147 6.147 0 015.351-3.746z"}})])
          )
        }
      }
    